import {
  LoginSection,
  LoginSectionHandle,
} from "@/components/molecules/Modals/SpecificModals/LoginSection";
import {
  favoritesFlowSelector,
  resetFavoritesFlow,
} from "@/redux/frontPage/frontPageSlice";
import { loadedContentSelector } from "@/redux/loadedContent/loadedContentSlice";
import { BREAKPOINTS } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { ClubStatsPanel } from "./ClubStatsPanel";

type Props = {
  loginRef: React.RefObject<LoginSectionHandle | null>;
  onScreenChange: (screen: "email" | "code") => void;
  onLoginSuccess: () => void;
};

export const LoginStep = ({
  loginRef,
  onScreenChange,
  onLoginSuccess,
}: Props) => {
  const { t } = useTranslation("frontPage");
  const dispatch = useDispatch();
  const { clubs } = useSelector(loadedContentSelector);
  const { selectedClubIds, selectedCountryId } = useSelector(
    favoritesFlowSelector,
  );
  const chosenClubId = selectedClubIds[0] ?? null;
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);

  const chosenClub = useMemo(
    () => (clubs ?? []).find((c) => c.id === chosenClubId) ?? null,
    [clubs, chosenClubId],
  );

  return (
    <div className="flex flex-col gap-4 rounded-[20px] border border-neutral-700 bg-neutral-900 p-4">
      <h2 className="text-2xl font-medium tracking-tight text-neutral-100">
        {t("favorites.loginTitle")}
      </h2>

      {/* Don't delete this div, it's used to space the login section from the top of the page */}
      <div className="h-[32.5px]" />
      <div className="flex gap-3">
        <div className="flex-1 touch-device:rounded-[20px] touch-device:border border-neutral-700 touch-device:bg-neutral-800 touch-device:px-8 touch-device:py-8 flex flex-col items-center justify-center">
          <div className="w-full max-w-[320px]">
            <LoginSection
              ref={loginRef}
              newDesign
              onClose={() => dispatch(resetFavoritesFlow())}
              onScreenChange={onScreenChange}
              handleLoginSuccess={onLoginSuccess}
              favoriteClubs={selectedClubIds}
              favoriteCountries={
                selectedCountryId ? [selectedCountryId] : undefined
              }
            />
          </div>
        </div>
        {!isTouchDevice && <ClubStatsPanel club={chosenClub} />}
      </div>
    </div>
  );
};
